/**
 * Which guide explains the page at a given path — what the top bar's Help menu
 * offers first ("How the Letter Desk works").
 *
 * Its own small module, apart from helpCenter.ts, ON PURPOSE: the top bar is in
 * the bundle every visit downloads, and helpCenter.ts carries the whole FAQ for
 * its search. This file must import nothing heavier than opsNav.ts.
 */
import { OPS_PAGES, opsHelpHref } from '@/pages/ops/opsNav';

/** Most specific first: the first prefix a path starts with wins. */
export const PAGE_GUIDES: { prefix: string; label: string; href: string }[] = [
  { prefix: '/research/development', label: 'Development Opportunities', href: '/help/guide/development-opportunities' },
  { prefix: '/property-lists', label: 'Property Lists', href: '/help/guide/property-lists' },
  { prefix: '/portfolio', label: 'Portfolio', href: '/help/guide/portfolio' },
  { prefix: '/properties', label: 'Properties', href: '/help/guide/properties' },
  { prefix: '/ai-imports', label: 'AI Imports', href: '/help/guide/ai-import' },
  { prefix: '/deals', label: 'Deals', href: '/help/guide/deals' },
  { prefix: '/funds', label: 'Funds', href: '/help/guide/funds' },
  { prefix: '/offers', label: 'Offers', href: '/help/guide/offers' },
  { prefix: '/financing', label: 'Financing', href: '/help/guide/financing' },
  { prefix: '/tasks', label: 'Tasks', href: '/help/guide/tasks' },
  { prefix: '/diligence', label: 'Diligence', href: '/help/guide/diligence' },
  { prefix: '/contacts', label: 'Contacts', href: '/help/guide/contacts' },
  { prefix: '/owners', label: 'Owners', href: '/help/guide/owner-intelligence' },
  { prefix: '/skip-traces', label: 'Skip traces', href: '/help/guide/owner-intelligence' },
  { prefix: '/marketing', label: 'Marketing', href: '/help/guide/outreach' },
  { prefix: '/markets', label: 'Market Intelligence', href: '/help/guide/markets' },
  { prefix: '/reports', label: 'Reports', href: '/help/guide/analytics' },
];

/** The guide for the page at `pathname`, if one is written. */
export function helpForPath(pathname: string): { label: string; href: string } | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/') return { label: 'the Dashboard', href: '/help/guide/dashboard' };
  if (path === '/ops' || path.startsWith('/ops/')) {
    const page = Object.values(OPS_PAGES).find((p) => (p.id === 'overview'
      ? path === '/ops'
      : path === p.path || p.prefixes?.some((x) => path.startsWith(x))));
    if (!page) return { label: 'Research Ops', href: '/help/guide/research-ops' };
    return {
      label: page.id === 'overview' ? 'Research Ops' : `the ${page.title}`,
      href: opsHelpHref(page),
    };
  }
  const hit = PAGE_GUIDES.find((g) => path === g.prefix || path.startsWith(`${g.prefix}/`));
  return hit ? { label: hit.label, href: hit.href } : null;
}
